export const myLesson = {
    "not_lesson_yet": "Chưa có bài học nào",
    "completed_prerequisite_lessons": "Bạn chưa hoàn thành các bài học tiên quyết. Hãy học tập theo đúng lộ trình.",
};
